import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import language resources
import enTranslation from './locales/en.json';
import elTranslation from './locales/el.json';

// Configure i18next
i18n
  .use(LanguageDetector) // Automatically detect language
  .use(initReactI18next) // Pass i18n to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      el: {
        translation: elTranslation
      }
    },
    fallbackLng: 'el',
    interpolation: {
      escapeValue: false // React already escapes values
    }
  });

export default i18n; 